/*
 * @Author: Json Chen
 * @Date: 2021-12-08 20:12:59
 * @LastEditTime: 2022-06-10 17:09:05
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelRegistration/TermsAndConditions/index.tsx
 */
import React from 'react';
import TcTable from 'src/constrains/TermsAndConditionsTableSelection';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/SectionWrapper';
import { RegistrationErrorContext } from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelRegistration/ErrorContext';
import { i18nGet } from 'src/tools/tools';
const TermsAndConditions = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { tcError, setTcError } = React.useContext(RegistrationErrorContext);

  const { data, onChange, setHasModified, tcs, disableEdit } = props;
  const _onChange = (data) => {
    setTcError(false);
    if (onChange) {
      onChange(data);
    }
  };
  return (
    <SectionWrapper
      title={getI18n(
        'salesChannelRegistration.index.registrationTermsConditions',
      )}>
      <TcTable
        type='TcDrag'
        data={data}
        onChange={_onChange}
        disableEdit={disableEdit}
        setHasModified={setHasModified}
        tcs={tcs || []}
        error={{
          tcEmptyError: tcError,
          setTcEmptyError: setTcError,
        }}
        id='SalesChannelRegistrationTCTable'
      />
    </SectionWrapper>
  );
};
export default TermsAndConditions;
